<template>
  <div class="page_input">
    <div class="search-box">
      <img class="search-icon" src="/assets/img/News/search.png">
      <input type="text" 
      class="search-input" 
      :value="value" 
      @input="$emit('input', $event.target.value)"
      @keyup.enter="$emit('keyEnter', $event.target.value)"
        placeholder="Search" onfocus="this.placeholder=''" onblur="this.placeholder='Search'">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: String, // 接收父组件传递的 v-model 数据
  },
};
</script>
<style scoped>
  input::placeholder {
        color: #72777b; /* 设置占位符文字颜色为灰色 */
        font-size: 14px; /* 可选：设置字体大小 */
        opacity: 1;
        }
</style>
